import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGavel, faBell } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import instance from "../apiInstance";
import config from "../config";
import { appCopy } from "../pages/appCopy";
import "./AuctionOffReminder.css";

const DEFAULT_GROUP_INVITE = "https://chat.whatsapp.com/LPsjwnZmFJn8JaoICbQ5xW";

export default function AuctionOffReminder() {
  const t = appCopy(config.STORE_LOCALE);
  const [inviteUrl, setInviteUrl] = useState(DEFAULT_GROUP_INVITE);

  useEffect(() => {
    instance.get("/membership/promo-group")
      .then((res) => {
        if (res.data?.inviteUrl) setInviteUrl(res.data.inviteUrl);
      })
      .catch(() => {});
  }, []);

  return (
    <div className="auc-off-reminder">
      <div className="auc-off-reminder-icon">
        <FontAwesomeIcon icon={faGavel} />
      </div>
      <h3 className="auc-off-reminder-title">{t.auctionOffTitle}</h3>
      <p className="auc-off-reminder-text">{t.auctionOffBody}</p>
      <a
        href={inviteUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="auc-off-reminder-cta"
      >
        <FontAwesomeIcon icon={faWhatsapp} />
        {t.auctionOffGroupCta}
      </a>
      <p className="auc-off-reminder-notify">
        <FontAwesomeIcon icon={faBell} />
        {t.auctionOffNotifyHint}
      </p>
    </div>
  );
}
